import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { ParticipantsCategory, ParticipantsSelection } from 'types/typescript'
import { RemoveParticipantsWithBirthdates } from './types/removeParticipantsWithBirthdates.types'
import { cloneParticipantsObject } from '.'

export const removeParticipantsWithBirthdates: RemoveParticipantsWithBirthdates = (
  participants
) => (
  (PARTICIPANTS_CATEGORIES as ParticipantsCategory[]).reduce<DeepWriteable<ParticipantsSelection>>((participantsClone, category) => {
    const { birthdates } = participantsClone[category]
    const birthdatesNumber = birthdates.length

    if (birthdatesNumber) {
      participantsClone[category].birthdates = []
      participantsClone[category].number -= birthdatesNumber
    }
    return participantsClone
  }, cloneParticipantsObject(participants)) || participants
)
